// ACHTUNG!! Muss JSON sein, keine Komentare!
export default {
  "entrypoints": {
    "mainnavigation": {"php": true},
    "contact": {"php": false},
    "cookie-notice": {"php": false},
    "swiper": {"php": false},
    "lightgallery": {"php": false},
    "tabs": {"php": false},
    "map": {"php": false},
    "testimonial-app": {"php": false}
  }
}
